<template>
    <AppTabLinks :links="list" />
</template>

<script>
    import AppTabLinks from '@/components/AppTabLinks';

    export default {
        components: {
            AppTabLinks,
        },

        data() {
            return {
                isAuthorized: false,
                list: []
            }
        },
        mounted() {
            if(this.adminOnly()) {
                this.list = [
                    {
                        title: 'Карточка',
                        url: `/grocers/${this.$route.params.id}`,
                    },
                    {
                        title: 'Редактировать',
                        url: `/grocers/${this.$route.params.id}/edit`,
                    },
                    {
                        title: 'Описание',
                        url: `/grocers/${this.$route.params.id}/description`,
                    },
                    {
                        title: 'Дополнительное описание',
                        url: `/grocers/${this.$route.params.id}/additional-description`
                    },
                    {
                        title: 'Категории',
                        url: `/grocers/${this.$route.params.id}/categories`,
                    },
                    {
                        title: 'Товары',
                        url: `/grocers/${this.$route.params.id}/goods`,
                    },
                    {
                        title: 'Импорт',
                        url: `/grocers/${this.$route.params.id}/import`,
                    },
                    {
                        title: 'Акции',
                        url: `/grocers/${this.$route.params.id}/promotions`
                    },
                    {
                        title: 'Словарь',
                        url: `/grocers/${this.$route.params.id}/dictionary`
                    },
                    {
                        title: 'Доставка',
                        url: `/grocers/${this.$route.params.id}/delivery`,
                    },
                    {
                        title: 'Перенаправление доставки',
                        url: `/grocers/${this.$route.params.id}/delivery-address-redirect`
                    },
                    {
                        title: 'Настройки по башням',
                        url: `/grocers/${this.$route.params.id}/tower-settings`
                    },
                    {
                        title: 'Настройки',
                        url: `/grocers/${this.$route.params.id}/settings`,
                    },
                ]
            } else {
                this.list = [
                    {
                        title: 'Карточка',
                        url: `/grocers/${this.$route.params.id}`,
                    },
                    {
                        title: 'Редактировать',
                        url: `/grocers/${this.$route.params.id}/edit`,
                    },
                    {
                        title: 'Описание',
                        url: `/grocers/${this.$route.params.id}/description`,
                    },
                    {
                        title: 'Категории',
                        url: `/grocers/${this.$route.params.id}/categories`,
                    },
                    {
                        title: 'Товары',
                        url: `/grocers/${this.$route.params.id}/goods`,
                    },
                ]
            }
        },
        methods: {
            adminOnly() {
                return !JSON.parse(localStorage.getItem('settings')).is_business_admin;
            },
        }
    };
</script>
